import { Dispatch } from 'redux';
import { intl } from '../../providers/IntlProvider';
import { ToastCategories, ToastTypes, ToastsActionTypes } from '../toasts';
import { addDocument, queryDocuments, removeDocument, updateDocument } from '../../services/api';
import { OrganisationDocumentsActionTypes } from '.';

interface DocumentPayload {
  payload: {
    form: FormData;
  };
}

interface DocumentIdPayload {
  payload: {
    id: string;
  };
}

interface DocumentUpdatePayload {
  payload: {
    id: string;
    form: FormData;
  };
}

export const getDocuments =
  () =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await queryDocuments();
    dispatch({
      type: OrganisationDocumentsActionTypes.SET_DOCUMENTS,
      payload: response,
    });
  };
export const add =
  ({ payload }: DocumentPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await addDocument(payload);
    dispatch({
      type: OrganisationDocumentsActionTypes.SAVE,
      payload: response,
    });
    dispatch({
      type: ToastsActionTypes.ADD_TOAST,
      payload: {
        title: intl.formatMessage({ id: 'message.onFileSuccess' }),
        type: ToastTypes.SUCCESS,
        category: ToastCategories.FLASH,
        message: '',
      },
    });
  };
export const remove =
  ({ payload }: DocumentIdPayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    await removeDocument(payload);
    dispatch({
      type: OrganisationDocumentsActionTypes.REMOVE_DOCUMENT,
      payload: {
        removeId: payload.id,
      },
    });
  };
export const update =
  ({ payload }: DocumentUpdatePayload) =>
  async (dispatch: Dispatch): Promise<void> => {
    const response = await updateDocument(payload);
    dispatch({
      type: OrganisationDocumentsActionTypes.SAVE,
      payload: response,
    });
    dispatch({
      type: ToastsActionTypes.ADD_TOAST,
      payload: {
        title: intl.formatMessage({ id: 'message.onFileUpdate' }),
        type: ToastTypes.SUCCESS,
        category: ToastCategories.FLASH,
        message: '',
      },
    });
  };
